type RequestType = "GET" | "POST" | "PUT" | "DELETE";

export class ApiRequest {
  private _path: string;
  private _type: RequestType;
  private _payload?: any;

  public constructor(path: string, type: "GET" | "POST" | "PUT" | "DELETE", payload?: any) {
    this._path = path;
    this._type = type;
    this._payload = payload;
  }

  public get path(): string {
    return this._path;
  }

  public get type(): RequestType {
    return this._type;
  }

  public get payload(): any {
    return this._payload;
  }
}
